module.exports = __webpack_public_path__ + "components/flag/static/square/tm-ed81c4464982d1e75af7f3a3277754bb.svg";